const presetElements = [
  {
    type: 'cascader',
    element: 'el-cascader'
  },
  {
    type: 'cascader-disabled',
    element: 'el-cascader',
    attrs: {
      disabled: true
    }
  },
  {
    type: 'cascader-clearable',
    element: 'el-cascader',
    attrs: {
      clearable: true
    }
  },
  {
    type: 'cascader-multiple',
    element: 'el-cascader',
    attrs: {
      multiple: true
    }
  },
  {
    type: 'cascader-medium',
    element: 'el-cascader',
    attrs: {
      size: 'medium'
    }
  },
  {
    type: 'cascader-small',
    element: 'el-cascader',
    attrs: {
      size: 'small'
    }
  },
  {
    type: 'cascader-mini',
    element: 'el-cascader',
    attrs: {
      size: 'mini'
    }
  }
]

export default presetElements
